<template>
  <ul class="socialLinks">
    <template>
      <li
        v-for="(social, index) in links"
        :key="index"
        class="socialLinks__item"
        :class="{ hidden: !social.url }"
      >
        <a
          :href="social.url"
          :title="social.title"
          @click="handleClickPhoneLink(social, $event)"
          class="socialLinks__link"
        >
          <gl-svg-icon :icon="social.name" height="32" width="32" />
        </a>
      </li>
    </template>

    <gl-popup
      v-if="isShowPopup"
      @close="handleClickClosePopup"
      class-modifier="medium"
    >
      <div class="popupContent">
        <gl-svg-icon icon="popup-phone" width="64" hight="64" />
        <p class="popupContent__text">{{ phoneNumberForPopup }}</p>
        <p class="popupContent__title">{{ $t("Phone Number") }}</p>
        <button
          v-clipboard="phoneNumberForPopup"
          class="popupContent__btn btnFarm btnFarm--outline-primary"
        >
          {{ $t("Copy") }}
        </button>
      </div>
    </gl-popup>
  </ul>
</template>

<script>
import MobileDetect from "mobile-detect";
import GlSvgIcon from "@gl/GlSvgIcon";
import GlPopup from "@gl/GlPopup";

const md = new MobileDetect(window.navigator.userAgent);
const isMobile = md.mobile();

export default {
  name: "ProfileSocialLinks",
  components: {
    GlPopup,
    GlSvgIcon,
  },
  props: {
    links: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      isShowPopup: false,
      phoneNumberForPopup: null,
    };
  },
  methods: {
    handleClickPhoneLink({ name, url }, event) {
      event.preventDefault();

      if (!isMobile && name === "phone") {
        this.phoneNumberForPopup = url.split("tel:")[1];
        this.isShowPopup = true;
      } else if (!isMobile && name === "instagram") {
        window.open(url);
      } else {
        window.open(url, "_self");
      }
    },
    handleClickClosePopup() {
      this.isShowPopup = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.socialLinks {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin-top: 14px;

  @media (min-width: $breakpoint-md) {
    width: 100%;
    margin-top: 30px;
  }

  &__item {
    padding: 10px;
    margin: 0 6px;
    border-radius: 6px;

    &:hover {
      background-color: #2f72e0;
    }
  }

  &__link {
    align-items: center;
    display: flex;
    justify-content: center;
    width: 100%;
  }
}

.popupContent {
  text-align: center;
  padding-top: 24px;

  &__title {
    color: #000000de;
    font-size: 14px;
    line-height: 24px;
    font-family: $font-family;
    font-weight: 400;
    margin-top: 8px;
    @media (min-width: $breakpoint-md) {
      margin-top: 16px;
    }
  }

  &__text {
    font-size: 18px;
    line-height: 24px;
    font-family: $font-secondary;
    font-weight: 700;
    letter-spacing: 0.15em;
    margin-top: 24px;
    @media (min-width: $breakpoint-md) {
      margin-top: 32px;
    }
  }

  &__btn {
    margin-top: 24px;
    width: 100%;

    @media (min-width: $breakpoint-md) {
      width: initial;
    }
    @media (min-width: $breakpoint-xl) {
      margin-top: 32px;
    }
  }
}
</style>
